import { render, staticRenderFns } from "./CustomRenderer.vue?vue&type=template&id=9ffa9f50&"
import script from "./CustomRenderer.vue?vue&type=script&lang=js&"
export * from "./CustomRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports